/**
 * Closed-testing allowlist — the SINGLE source of truth for TypeScript.
 *
 * While the app is public but still in testing we only admit a fixed set of
 * Google accounts. This list previously existed in three hand-maintained
 * copies (the API callables, the web client's build-time env, and the Firestore
 * rules), which could drift silently: a tester added to the rules but not to
 * `createBusiness` gets a confusing permission error instead of an account.
 *
 * Firestore rules cannot import TypeScript, so `firestore/firestore.rules`
 * still carries its own literal copy — but `allowlist.test.ts` parses that file
 * and fails the build when the two disagree, which is what makes this a single
 * source of truth in practice rather than in intent.
 *
 * The rules are the REAL enforcement boundary for client reads/writes. Admin-SDK
 * callables bypass rules, so any callable that creates a top-level document
 * (i.e. isn't transitively gated by an existing owned business) must re-check
 * this list itself.
 *
 * To open the app up publicly: empty this list, drop `&& isAllowedTester()` from
 * the rules, and delete the callable checks — all in one commit.
 */
export const ALLOWED_TESTERS = [
    'verber33@gmail.com',
    'andrey.ariesav@gmail.com',
    'barkhatov.den@gmail.com',
];
/** Whether an email may use the app. Case-insensitive; Google normalises
 * addresses to lowercase, but a token from another provider might not. */
export function isAllowedTester(email) {
    if (ALLOWED_TESTERS.length === 0)
        return true; // gate disabled
    return !!email && ALLOWED_TESTERS.includes(email.toLowerCase());
}
//# sourceMappingURL=allowlist.js.map